import { useState } from "react";
import { loginUserWithOtp, sendLoginOtp } from "../../../redux/auth/actions";
import { useDispatch, useSelector } from "react-redux";
import { Button, Form } from "react-bootstrap";
import { APP_CONST, OTP_TYPE } from "../../../config/const";
import PhoneInput from "react-phone-input-2";
import { Toaster } from "../../../utils/toaster";
import { parsePhoneNumber } from "libphonenumber-js";
import BackArrow from "../../../assets/svg/back-arrow.svg";
import { useTranslation } from "react-i18next";
import { getBrowserKey } from "../../../utils/broswerFingerprint";

const LoginWithOtp = ({ setModalState }) => {
  const dispatch = useDispatch();
  const [mobileNumber, setMobileNumber] = useState("");
  const [otp, setOtpValue] = useState("");
  const [isOtpSent, setIsOtpSent] = useState(false);
  const appDetails = useSelector((state) => state.app?.appDetails);
  const [email, setEmail] = useState({ email: "" });
  const [isSendingOtp, setIsSendingOtp] = useState(false);
  const isEmailOtpRequired = appDetails?.IS_EMAIL === 1;
  const isOtpRequired = appDetails?.OTP === 0;

  const { t } = useTranslation();

  const handleSendLoginOtp = async (e) => {
  e.preventDefault();

  if (isSendingOtp) return;

  setIsSendingOtp(true);

  try {
    if (isEmailOtpRequired && !email?.email) {
      Toaster(APP_CONST.TOAST_TYPE.ERROR, "Email is required");
      return;
    }

    if (!isEmailOtpRequired && isOtpRequired && !mobileNumber) {
      Toaster(APP_CONST.TOAST_TYPE.ERROR, "Mobile number is required");
      return;
    }

    let payload = {};
    const bKey = await getBrowserKey();

    if (isEmailOtpRequired) {
      payload = { emailOrMobile: email.email, type: OTP_TYPE.EMAIL, bKey };
    } else if (isOtpRequired) {
      let phoneNumber;
      try {
        phoneNumber = parsePhoneNumber("+" + mobileNumber);
      } catch {
        Toaster(APP_CONST.TOAST_TYPE.ERROR, "Invalid mobile number");
        return;
      }

      payload = {
        emailOrMobile: phoneNumber.countryCallingCode + phoneNumber.nationalNumber,
        type: OTP_TYPE.MOBILE,
        bKey,
      };
    } else {
      Toaster(APP_CONST.TOAST_TYPE.ERROR, "OTP is not enabled for this account");
      return;
    }

    const res = await sendLoginOtp(payload);
    if (res?.data?.error === false) {
      setIsOtpSent(true);
      Toaster(APP_CONST.TOAST_TYPE.SUCCESS, "OTP sent");
    } 
  } catch (err) {
    console.error(err);
  } finally {
    setIsSendingOtp(false);
  }
  };


  const handleVerifyLoginOtp = async () => {
    if (!otp) {
      Toaster(APP_CONST.TOAST_TYPE.ERROR, "OTP is required");
      return;
    }

    // Validate 
    if (isEmailOtpRequired && !email?.email) {
      Toaster(
        APP_CONST.TOAST_TYPE.ERROR,
        "Email is required to login with OTP"
      );
      return;
    }

    if (!isEmailOtpRequired && isOtpRequired && !mobileNumber) {
      Toaster(
        APP_CONST.TOAST_TYPE.ERROR,
        "Mobile number is required to login with OTP"
      );
      return;
    }

    const bKey = await getBrowserKey();

    let payload = { otp, key: "", bKey };

    if (isEmailOtpRequired) {
      payload.key = email.email;
    } else if (isOtpRequired) {
      payload.key = mobileNumber;
    } else {
      Toaster(
        APP_CONST.TOAST_TYPE.ERROR,
        "OTP login is not allowed for this account"
      );
      return;
    }

    dispatch(loginUserWithOtp(payload));
  };

  return (
    <div className={"login-section ForgotPasswordSection"}>
            <div className="Login-rightPart">
              <div className="inner-wrapper">
                <div className="right-content">
                  <div className="password-content">
                   <h2 className="title">{t("login_with_otp")}</h2>
                    <div className="form-steps">
                      <Form>
                         {isOtpRequired && (
                          <Form.Group
                            className="mb-4 position-relative"
                            controlId="formBasicPassword"
                          >
                            <PhoneInput
                              country={"tm"}
                              countryCodeEditable={false}
                              inputProps={{
                                name: "phone",
                              }}
                              // onlyCountries={["in"]}
                              inputStyle={{
                                width: "100%",
                              }}
                              onChange={(phone) => {
                                setMobileNumber(phone);
                              }}
                            />
                          </Form.Group>
                        )}
                        {isEmailOtpRequired && (
                          <Form.Group
                            className="mb-3 position-relative"
                            controlId="formBasicPassword"
                          >
                            <Form.Control
                              type="email"
                              placeholder={t("enter_email *")}
                              value={email.email}
                              onChange={(e) =>
                                setEmail({ email: e.target.value })
                              }
                            />
                          </Form.Group>
                        )}
                        <Button
                          variant="primary mb-4"
                          type="submit"
                          onClick={handleSendLoginOtp}
                        >
                          {t("get_OTP")}
                        </Button>

                        <Form.Group
                          className="mb-4 position-relative"
                          controlId=""
                        >
                          <Form.Control
                            type="text"
                            placeholder={t("enter_OTP *")}
                            onChange={(e) => setOtpValue(e.target.value)}
                            autoComplete="off"
                          />
                        </Form.Group>

                        <div className="sbmt-back">
                          <a
                            href="#"
                            className="back-btn"
                            onClick={() =>
                              setModalState("login")
                            }
                          >
                            <img src={BackArrow} alt="back" />
                          </a>
                          <Button
                            variant="primary"
                           onClick={handleVerifyLoginOtp}
                           disabled={!isOtpSent}
                          >
                             {t("login")}
                          </Button>
                        </div>
                      </Form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
  );
};
export default LoginWithOtp;
